<template>
 <div id="qdirect">
 	<mt-header :title="title"  fixed>
	  <a href="javascript:void(0)" slot="left" @click="returnBack">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
	   </a>
	</mt-header>
	<div class="mt40" v-show="typeLength!=''">
		<div class="bgcontent border-bottom-line" v-if="typeLength>1">
	 	 	<mt-radio title="商品类型" v-model="value" :options="options" @change="check"></mt-radio>
	 	 </div>
	 	 <div v-else>
	 	  <mt-field label="商品类型"  v-model="value"  disabled class="border-bottom-line"></mt-field>
	 	 </div>
 	 </div>
 	 
 	<div class="bgcontent" v-show="type==2">
	 	<div>
		 	 <mt-field label="QQ号码" placeholder="请输入QQ号码" type="number" v-model="qnumber" :attr="{ maxlength: 15 }" class="border-bottom-line"></mt-field>
		 	 <div @click="selectAdress" class="border-bottom-line">
			  	<mt-cell title="常登录地"  class="addressVlaue">
			  		<span class="land">{{addprovinces}}</span>
			  		<span class="land">{{addcity}}</span>
			  	</mt-cell>
		     </div>
		     <mt-popup v-model="addressVisible" position="bottom">
	                 <mt-picker :slots="addressSlots" @change="onValuesChange" :showToolbar="true" value-key="name" >
	               	   <span class="float-left"  @click="cancelAddress">取消</span>
	               	   <span class="float-right" @click="confirmAddress">完成</span>
	                 </mt-picker>
	         </mt-popup>
		</div>
	 	<div class="border-bottom-line">
	 	 <div class="faceValueBox">
	 	 	<ul class="faceValue">
	 	 	 <li v-for="(item,index) in parvalue" :class="{mr0:(index+1) % 3==0,active:currentIndex==index}" @click="payType(index)">
	 	 	 	<p class="font-size9 qcoins"><span><strong>{{item.proName}}</strong></span><span class="font-size8 element"><br>￥{{item.price}}元</span></p>
	 	 	 </li>
	 	 	 <li :class="currentIndex==-1?'active':''" class="mr0">
	 	 	 	<span v-if="showOtherValue==1" @click="faceValueFocus">
	 	 	 	<p class="font-size9 qcoins Qmain"><span><strong>{{otherFaceValue}}Q币</strong></span><span class="font-size8 element"><br>￥{{price}}元</span></p>
	 	 	 	</span>
	 	 	 	<span v-else>
	 	 	 		<input placeholder="其它面值" type="number"class="otherValue" v-model="otherFaceValue" @input="handleInput" @blur="faceValueBlur2" @focus="focusinput"/> <!--@input="handleInput"-->
	 	 	 	</span>
	 	 	 	<!--@blur="faceValueBlur"-->
	 	 	 	<!--oninput="value=value.replace(/[^\d]/g,'')"-->
	 	 	 </li>
	 	 	</ul>
	 	 </div>     
	 	</div>
 	</div>
 	<div class="bgcontent" v-show="type==1">
 	<div class="border-bottom-line">
 	  <div class="faceValueBox">
 	  	<ul class="faceValue">
 	 	 <li v-for="(item,index) in parvalue" :class="{mr0:(index+1) % 3==0,active:currentIndex==index}" @click="payType(index)">
 	 	 	<p class="font-size9"><strong>{{item.proName}}</strong></p>
 	 	 </li>
 	 	</ul>
 	  </div>
 	 </div>
 	 <div class="border-bottom-line">
 	   <mt-field label="数量"  v-model="num" type="number"  v-on:input="checkNum"><i class="numtip">限购10张</i></mt-field>
 	 </div>
 	</div>
 	<div class="bgcontent">
 	   <dl class="purchase">
 	   	 <dt>
 	   	 	<p class="colorff8900 font-size10" v-show="price!=''"><strong>{{totPrice}}元</strong></p>
 	   	 	<!--<p class="colorff5513 font-size8" v-show="vcoin!=''">{{vcoin}}V</p>
 	   	 	<p class="font-size8 color999" v-show="payTypes!=''">支持<label>{{payTypes}}</label></p>-->
 	   	 </dt>
 	   	 <!--<dd v-show="type==2"><mt-button type="primary" size="small" class="font-Yahei btnbuy">确认面值</mt-button></dd>-->
 	   	 <dd><mt-button type="primary" size="small" class="font-Yahei btnbuy" @click="btnBuy" v-show="paysType!=''" >{{type==2?'立即充值':'立即购买'}}</mt-button></dd>
 	   </dl>
 	</div>
 	<div class="bgcontent">
 		<div class="dec">
 			<p class="mb5">商品适用游戏：{{game}}</p>
 			<div  v-html="dec"></div>
 		</div>
 	</div>
 	<!--<p>{{faceId}}</p>-->
 </div>
 
</template>

<script>
import { Toast } from 'mint-ui'
import { Indicator } from 'mint-ui'

	export default{
		data(){
			return{
			   value:"",
			   type:"",
			   qnumber:"",
			   tid:localStorage.getItem("tid"),
			   ttype:localStorage.getItem("ttype"),
			   faceId:localStorage.getItem("faceId"),
			   typeLength:"",
			   options:[],
			   num:1,
			   parvalue:[],
			   price:"",
			   //vcoin:"",
			   //payTypes:"",
			   currentIndex:"",
			   dec:"",
			   title:"",
			   paysType:[],
			   proName:"",
			   pic:"",
			   pid:"",
			   game:"",//适用游戏
			   username:localStorage.getItem("username"),
			   addressVisible:false,
			   addressSlots: [{
			          flex: 1,
			          values:[],
			          className: 'slot1',
			          textAlign: 'center'
			        }, {
			          divider: true,
			          content: '-',
			          className: 'slot2'
			        }, {
			          flex: 1,
			          values:[],
			          className: 'slot3',
			          textAlign: 'center'
			        }],
		      addprovinces:"请选择",//省份
		      addcity:"",//城市
		      citycode:"",//市区区号
		      provinces:"",
		      city:"",
		      otherFaceValue:"",
		      showOtherValue:0,
		      currentIndexLast:"",
		      priceNum:"",
		      totPrice:""
			}
		},
		created:function(){
			this.showType();
	    },
	    methods: {
	    	returnBack(){
	       	 this.$router.go(-1);
	        },
	        //数量金额
		     checkNum(){
		     	if(this.type==1){
			     if(this.num<1||this.num==""){
		     		this.totPrice=this.priceNum;
		     	  }else if(this.num>10){
			     		Toast("购买数量最多10张");
			     	}else{
			     		this.totPrice=(this.priceNum*this.num).toFixed(2);
			     	}
		     	}
		     },
	        //点击常登录地
	        selectAdress(){
	        	this.addressVisible=true;
	        	this.addressProvince();
	        	
	        },
	        cancelAddress(){
	            this.addressVisible=false;
	        },
	        //确认登录地
	        confirmAddress(){
	        	this.addprovinces=this.provinces;
	        	this.addcity=this.city;
	        	//this.citycode=this.city.citycode;
	        	this.addressVisible=false;
	        },
	        onValuesChange(picker, values){
	        	var code;
	        	if(values[0] != "undefined" && values[0] != this.provinces){
	        	  //请求市
		          /*this.$http.post(this.URL_PREFIX+"/city/obtainCity.net",{province:values[0]})
			  	  .then((res) =>{
			  	  	  if(values[0]=='台湾省'){
			  	  	  	 let citylist=[{citycode:"010",name:"台湾地区"}];
                         picker.setSlotValues(1, citylist);
			  	  	  }else{
			  	  	  	let citylist=res.data.obj.citys;
                        picker.setSlotValues(1, citylist); 
			  	  	  }   
			  	  }); */
			  	 
	             this.$http.get("../../../static/json/data.json").then((res) =>{
	             	let index;
		  	  	      $.each(res.data, function(i, item) {
				            if(values[0]==item.Province){
				            	index=i;
				            	return;
				            }
				     });
				     try{
				     	let shi="";
					     $.each(res.data[index].CityList, function(i, item) {
					            	shi+=item.City+","
					     });
					     var c= shi.substring(0,shi.length-1);
					     var city = c.split(",");
					     picker.setSlotValues(1, city); 
				     }catch(e){
				     	//TODO handle the exception
				     }
				    
		  	  	});
		  	  	
		  	  	    
	          }
	        	this.provinces=values[0];
	        	//获取市区号
	        	if(values[1] != undefined||values[1] != "undefined"){
	        		 this.city=values[1];
	        		 this.$http.get("../../../static/json/data.json").then((res) =>{
	        		 	let index;
	        		 	$.each(res.data, function(i, item) {
				            if(values[0]==item.Province){
				            	index=i;
				            	return;
				            }
				        });
				        try{
				        	 $.each(res.data[index].CityList, function(i, item) {
				        	   if(item.AreaCode==""){
				            		item.AreaCode="010"
				            	}
				            	if(values[1]==item.City){
				            		code=item.AreaCode;
				            	}
					        });
					         this.citycode=code;
				        }catch(e){
				        	//TODO handle the exception
				        }
				       
	        		 });
	        	}
	        },
	        //请求省
	        addressProvince(){
	        	/*if(this.username==null){
	        		this.username="";
	        	}
			  	this.$http.post(this.URL_PREFIX+"/city/obtainCity.net",{phone:this.username}).then((res) =>{
			  		let delete_ao=res.data.obj.provinces.splice(0,1);//澳
			  		let delete_g=res.data.obj.provinces.splice(27,1);//香港
			  		let delete_tai=res.data.obj.provinces.splice(8,1);//台
			  		let new_array=res.data.obj.provinces.concat(delete_g,delete_ao,delete_tai);
			  		this.addressSlots[0].values =new_array;
		  	  	    //this.addressSlots[0].values = res.data.obj.provinces;
		  	  	    console.log(res.data.obj+"省份");
		  	  	});*/
		  	  	this.$http.get("../../../static/json/data.json").then((res) =>{
		  	  	     var shen="";
		  	  	     $.each(res.data, function(i, item) {
				            	shen+=item.Province+","
				     });
				     var s= shen.substring(0,shen.length-1);
				     var province = s.split(",");
				     this.addressSlots[0].values=province;
		  	  	});
		  	  	  
	        },
	    	showType(){
	      	this.$http.post(this.URL_PREFIX+"/category/findCategoryTopTypeById.net",{tid:this.tid,proType:this.ttype})
		  	.then((res) =>{
		  	  this.game=res.data.obj.game;
		  	  this.typeLength=res.data.obj.proType.length;
		  	  if(this.typeLength>1){
		  	  	 this.options=res.data.obj.proType;
		  	  	 
		  	  	 if(this.ttype!=null){ 
		  	  	 	 this.value=this.ttype;
		  	  	 	 this.type=this.value;
		  	  	 }else{
		  	  	 	this.value=this.options[1].value;//默认取直充;
		  	  	    this.type=this.value;
		  	  	 }
		  	  }else{
		  	  	 this.value=res.data.obj.proType[0].label;
		  	     this.type=res.data.obj.proType[0].value;
		  	  }         
		  	  this.showInfo();
		   });     
	     },
	     showInfo(){      
	     	this.$http.post(this.URL_PREFIX+"/category/findCategoryTopTypeById.net",{tid:this.tid,proType:this.type})
		  	.then((res) =>{
		  		  this.parvalue=res.data.obj.products;
		  		  //console.log(this.parvalue)
		  		  this.title=res.data.obj.tName;
		  		  this.dec=res.data.obj.proIntroduce;
		  	      var faceId=this.faceId;  
		  		  var faceIdi;
		  		  if(faceId!=null){
			  		  this.parvalue.forEach(function(item,i){
			  		  	if(item.id==faceId){
			  		  	    faceIdi=i;
			  		  		return;
			  		  	}
				      });
				      this.payType(faceIdi); 
				      this.faceId=null;
			     }else{
			       this.payType(0); 
			     }
		   });
	     },
	     check(val){
	     	this.type=val;
	     	this.showInfo();
	     },
	     payType(i){
	     	this.num=1;
	     	this.currentIndex=i;
	     	this.currentIndexLast=i;
	     	this.price=this.parvalue[i].price;
	     	this.priceNum=this.parvalue[i].price;
	     	this.totPrice=this.parvalue[i].price;
	     	//this.vcoin=this.parvalue[i].payInfo.price;
	     	//this.payTypes=this.parvalue[i].payInfo.body;
	     	this.paysType=this.parvalue[i].payType;//获取支付方式
	     	//console.log(1+this.paysType);
	     	this.proName=this.parvalue[i].proName;//获取面值名称
	     	if(this.parvalue[i].pics!=null){
	     	 this.pic=this.parvalue[i].pics.file;//获取面值图片
	     	 //console.log(this.pic);
	     	}
	     	this.pid=this.parvalue[i].pid;//商品pid
	     	this.showOtherValue=0;
	     	this.otherFaceValue='';
	     },
	     btnBuy(){
	     	localStorage.setItem("price",this.price);
	     	localStorage.setItem("proName",this.proName);
	     	localStorage.setItem("type",this.type);
	     	localStorage.setItem("pic",this.pic);
	     	localStorage.setItem("tName",this.title);
	     	localStorage.setItem("pid",this.pid);
	     	var obj=JSON.stringify(this.paysType);
	     	localStorage.setItem("payType",obj);
	     	localStorage.setItem("num","");//数量
	     	localStorage.setItem("totalPrice","");//总金额
	     	localStorage.setItem("citycode","");//常登陆地
	     	localStorage.setItem("purpose","");//购买用途
	     	localStorage.setItem("account","");
	     	if(this.type==1){
	     	   if(this.validateNum()){
	     	   	  var totalPrice=(this.price*this.num).toFixed(2);
	     	   	  localStorage.setItem("num",this.num);
	     	   	  localStorage.setItem("totalPrice",totalPrice);
	     	   	  this.validateStock();
	     	   }
	     	}else{
	     	   if(this.validateQq()){
	     	   	  if(this.addprovinces=="请选择"){
	     	   	  	  Toast("请选择常登录地");
	     	   	  }else {    //if(this.faceValueBlur())
	     	   	  	localStorage.setItem("citycode",this.citycode);//常登陆地
	     	   	    localStorage.setItem("account",this.qnumber);
	     	   	    localStorage.setItem("num",this.num);	     	   	    
	     	   	    this.$router.push({path: '/Order/index'});
	     	   	  }
	     	   }
	     	}	     	
	     },
	     //库存风控验证
	     validateStock(){
	     	Indicator.open();
	     	this.$http.post(this.URL_PREFIX+"/order/exisStock.net",{proId:this.pid,num:this.num})
		  	.then((res) =>{
		  	  	 Indicator.close();
		  	  	 if(res.data.code==200){
		  	  	 	this.$router.push({path: '/Order/index'});
		  	  	 }else{
		  	  	 	Toast(res.data.msg);
		  	  	 }
		    });
	     },
	     //input框获取焦点
	     focusinput(){
	       this.currentIndex=-1;
	       this.price='';
	       //this.vcoin='';
	       this.paysType=[];
	       //this.payTypes='';
	       this.game='';
	       this.otherFaceValue='';
	     },
	     //input框失去焦点
	     faceValueBlur2(){
	     	this.showOtherValue=1;
	     },
	     //其它面值  失去焦点
	     faceValueBlur(){
	     	if(this.otherFaceValue!=0&&this.otherFaceValue>100){
                this.showOtherValue=0;
	     		this.payType(this.currentIndexLast);
	     		Toast("面值输入最大为100");
			  
	     	}else if(this.otherFaceValue==""||this.otherFaceValue==0){
	     		this.showOtherValue=0;
	     		this.payType(this.currentIndexLast);
	     		Toast("面值输入最小为1");
	     	}else{
	     		this.showOtherValue=0;
	     		this.currentIndex=-1;
	     		Indicator.open();
	     		this.$http.post(this.URL_PREFIX+"/order/customQProduct.net",{count:this.otherFaceValue})
			  	.then((res) =>{
			  	  	Indicator.close();
			  	  	this.num=this.otherFaceValue;
			  	  	this.price=((res.data.price)*(this.otherFaceValue)).toFixed(2);
			  	  	this.totPrice=this.price;
			     	//this.vcoin=res.data.payInfo.price;
			     	//this.payTypes=res.data.payInfo.body;
			     	this.paysType=res.data.payType;//获取支付方式
			     	this.proName=this.otherFaceValue+"Q币";//获取面值名称
			     	if(res.data.pics!=null){
			     	 this.pic=res.data.pics.file;//获取面值图片
			     	}
			     	this.pid=res.data.pid;//商品pid
			     });
	     	}
	     	
	     },
	     //其它面值 获取焦点
	     faceValueFocus(){
	     	this.showOtherValue=0;
	     },
	     //其它面值 控制只能输入数字
	     handleInput(e){
	     	//this.currentIndex=-1;
            this.otherFaceValue=e.target.value=e.target.value.replace(/[^\d]/g,'');
            this.faceValueBlur();
	     },
	     //QQ号验证
	     validateQq(){
	     	var reg=/^[1-9]\d{4,14}$/;
	     	if(this.qnumber==""){
	     	  Toast("请输入QQ号");
              return false;
	     	}else if(!reg.test(this.qnumber)){
	     	  Toast("QQ号输入有误");
              return false;
	     	}else{
	     	  return true;
	     	}
	     },
	     //数量验证
     	validateNum(){
     	   var reg=/^(0|[1-9]\d*)$/;
     	   if(this.num==""){
     	   	  Toast("请输入购买数量");
              return false;
     	   }else if(!reg.test(this.num)){
     	   	  Toast("输入数量格式有误,限购1-10张");
              return false;
     	   }else if(this.num>10){
     	      Toast("购买数量最多10张");
              return false;
     	   }else if(this.num<1){
     	   	  Toast("购买数量最少1张");
     	   	  this.num=1;
              return false;
     	   }else{
     	   	  return true;
     	   }
     	},
	    }
	}
</script>

<style scoped="scoped">
.faceValueBox{width: 95%;margin: 0 auto;padding: 15px 0 5px 0;overflow: hidden;}
.faceValue li{float: left; border:1px solid #ff8900; color: #ff8900;border-radius: 5px;-webkit-border-radius: 5px;width: 30%;margin: 0 4% 4% 0;display: -webkit-flex;display:flex;-webkit-align-items: center;align-items: center;-webkit-justify-content: center;justify-content: center;height: 60px;text-align: center;}
.faceValue li.mr0{margin-right: 0;}
.faceValue li.active{background: #ff8920;color: #fff;border:1px solid #ff8920;}
.faceValue li p.element{color: #ff5513;}
.faceValue li.active p.element{color: #fff;}
.faceValue li span input.otherValue{width: 95%;text-align: center;line-height: 45px;border:none;font-size: 1.0rem;color:#ff8920;font-weight: bold;}
.numtip{color: red;font-size: 0.7rem;margin-left: 10px;}
.purchase{padding: 20px 15px;border-bottom: 1px solid #e0e0e0;overflow: hidden;}
.purchase dt{width: 65%;float: left;line-height: 23px;margin-top: 6px;}
.purchase dd{float: right;/*margin-top: 3%;*/}
.purchase dd button{line-height: 33px;}
.dec{width: 92%;margin: 0 auto;color: #999;font-size: 0.8rem;padding: 10px 0 20px 0;line-height: 20px;}
</style>


// WEBPACK FOOTER //
// src/views/Details/QDirect.vue